// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventLastPlayedGetBody = {
  leagueId: string;
  timeZone: string;
};

export type typeEventLastPlayedGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    timeZone: string;
    hasEverPlayed: boolean;
    lastPlayedDay: string | null;
    seasonId: string | null;
  };
};

export type typeEventLastPlayedGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLastPlayedGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLastPlayedGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventLastPlayedGetBody = {
  type: "object",
  properties: {
    leagueId: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["leagueId", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventLastPlayedGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventLastPlayedGetBody);
  }

  return async function postEventLastPlayedGet(
    payload: typeEventLastPlayedGetBody,
  ): Promise<
    typeEventLastPlayedGetOutput200 | typeEventLastPlayedGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventLastPlayedGet" failed before calling the network. #be5f7f024483`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#be5f7f024483" },
        },
        data: null,
      } as typeEventLastPlayedGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/last-played-get`,
      httpMethod: "POST",
      options,
    })) as typeEventLastPlayedGetOutput200 | typeEventLastPlayedGetOutput400;
  };
}
